import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { AgentService } from '../services/agent.service';
import { AgentPartyContactHandlerComponent } from './agent-party-contact.handler';
import { FieldItem } from 'src/app/models/common/field-item';

@Component({
  selector: 'sym-agent-party-contact',
  templateUrl: './agent-party-contact.component.html',
  styleUrls: ['./agent-party-contact.component.scss'],
})
export class AgentPartyContactComponent extends AgentPartyContactHandlerComponent implements OnChanges {
  @Input() partyModel: any;

  constructor(agentService: AgentService, public settingService: SettingService) {
    super(agentService);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['partyModel'] && changes['partyModel'].currentValue) {
      this.partyModel = this.partyModel;
    }
  }
  contactNum_change(item: FieldItem) {
    this.service.checkForDuplicateMobileNo(item.fieldValue).subscribe(
      (successResponse) => {
        console.log('response', successResponse);
        if (!successResponse['success']) {
          this.warn(item.fieldValue + ' ' + this.settingService.getLabelValue('duplicateMobileNo'), () => {
            this.setFieldFocus(item.model, item.fieldCd);
            this.service.setModelFieldValue(item.model, item.fieldCd, null);
          });
        }
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }
}
